module.exports = __webpack_public_path__ + "img/appointment_a.8641e801.png";